import ImageLibrary from './ImageLibrary/ImageLibrary';
import NotesSection from './NotesSection';
import ReviewsSection from './ReviewsSection';
import GoogleBusinessProfileSection from './GoogleBusinessProfileSection/GoogleBusinessProfileSection';
import UnifiedAboutContent from './UnifiedAboutContent';

const RenderContent = ({ viewSelect, clientDetails }) => {
  let contentView;

  switch (viewSelect) {
    case 6:
      contentView = <ImageLibrary />;
      break;
    case 5:
      contentView = <ReviewsSection />;
      break;
    case 4:
      contentView = <GoogleBusinessProfileSection />;
      break;
    case 3:
      contentView = <NotesSection />;
      break;
    case 2:
    case 1:
    default:
      contentView = (
        <UnifiedAboutContent
          defaultData={clientDetails}
          callbackFromParent={() => {}}
        />
      );
      break;
  }
  return <div className="media-body h-100 p-2">{contentView}</div>;
};

export default RenderContent;
